<div class="modal-header">
    <div class="flex-fill hstack gap-2 justify-content-between">
        <h5 class="modal-title fw-semibold">
            <ng-container
                *ngIf="bookingDetails.cancellationChargeAmount !== null && !bookingDetails.hasUnpaidOrder"
            >
                Card Details
            </ng-container>
            <ng-container
                *ngIf="(bookingDetails.depositAmount !== null || bookingDetails.hasUnpaidOrder)"
            >
                {{ paymentTerminology.actionLabel }}
            </ng-container>
        </h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="dismiss()"
        >
        </button>
    </div>
</div>
<div class="modal-body">
    <app-spinner-overlay
        *ngIf="isLoadingVenue"
    >
    </app-spinner-overlay>
    <app-waiting-for-confirmation
        *ngIf="venue && isConfirmingPayment && !errorConfirmingPayment && !errorLoadingVenue"
        [venue]="venue"
        aria-live="polite"
    >
    </app-waiting-for-confirmation>
    <app-error
        *ngIf="errorLoadingVenue"
        [error]="'An error occurred while loading your booking. Please try again.'"
    >
    </app-error>
    <app-error
        *ngIf="errorConfirmingPayment"
        [error]="cardSetupFailed
            ? 'Your card could not be saved. Please try another card.'
            : 'We could not confirm your booking yet. Refresh to check again, or check your email for confirmation.'"
    >
    </app-error>
    <app-payment-details-form
        *ngIf="venue && bookingDetails.cancellationChargeAmount !== null && !bookingDetails.hasUnpaidOrder && !isConfirmingPayment"
        [showTitle]="false"
        [showBackButton]="false"
        [venue]="venue"
        [bookingDetails]="bookingDetails"
        [formGroup]="form"
        (paymentStarted)="confirmWithCardStarted('setupIntentId', $event)"
        (paymentFailed)="confirmWithCardFailed()"
    >
    </app-payment-details-form>
    <app-deposit-form
        *ngIf="venue && (bookingDetails.depositAmount !== null || bookingDetails.hasUnpaidOrder) && !isConfirmingPayment"
        [showTitle]="false"
        [showBackButton]="false"
        [venue]="venue"
        [bookingDetails]="bookingDetails"
        [formGroup]="form"
        (paymentStarted)="confirmWithCardStarted('paymentIntentId', $event)"
        (paymentFailed)="confirmWithCardFailed()"
    >
    </app-deposit-form>
</div>
